<template>
  <dashboard-widget title="INVENTORY VALUE" no-zoom @delete="$emit('delete','DashboardInventoryValue')" :width="width" :enableDelete="enableDelete">
    <v-container class="text-caption pt-8">
      <v-row @click="$router.push({name:'InventoryItems',query:{status:'2'}})">
        <v-col cols="6" class="py-2 pr-0">Items</v-col>
        <v-col class="text-right py-2">{{inventoryValues.items | currency}}</v-col>
      </v-row>
      <v-row @click="$router.push({name:'InventoryProducts',query:{status:'2'}})">
        <v-col cols="6" class="py-2 pr-0">In-bond products</v-col>
        <v-col class="text-right py-2">{{inventoryValues.inBondProducts | currency}}</v-col>
      </v-row>
      <v-row @click="$router.push({name:'InventoryProducts',query:{status:'2'}})">
        <v-col cols="6" class="py-2 pr-0">Duty-paid products</v-col>
        <v-col class="text-right py-2">{{inventoryValues.dutyPaidProducts | currency}}</v-col>
      </v-row>
      <v-row @click="$router.push({name:'EquipmentTanks',query:{status:'2'}})">
        <v-col cols="6" class="py-2 pr-0">Tanks</v-col>
        <v-col class="text-right py-2">{{inventoryValues.tanks | currency}}</v-col>
      </v-row>
      <v-row @click="$router.push({name:'InventoryCasks'})">
        <v-col cols="6" class="py-2 pr-0">Casks</v-col>
        <v-col class="text-right py-2">{{inventoryValues.casks | currency}}</v-col>
      </v-row>
      <v-row @click="$router.push({name:'InventoryBulkContainers'})">
        <v-col cols="6" class="py-2 pr-0">Bulk containers</v-col>
        <v-col class="text-right py-2">{{inventoryValues.bulkContainers | currency}}</v-col>
      </v-row>
      <v-row @click="$router.push({name:'EquipmentFermenters',query:{status:'2'}})">
        <v-col cols="6" class="py-2 pr-0">Fermenters</v-col>
        <v-col class="text-right py-2">{{inventoryValues.fermenters | currency}}</v-col>
      </v-row>
      <v-row class="font-weight-bold text-body-2">
        <v-col cols="6" class="py-2 mt-2 pr-0">Total</v-col>
        <v-col class="text-right py-2 mt-2" style="border-top:thin solid #666">{{total | currency}}</v-col>
      </v-row>
    </v-container>
  </dashboard-widget>
</template>

<script>
export default {
  name: 'DashboardInventoryValue',
  props: {
    width: {type:Number, required:false, default:290},
    enableDelete: {type: Boolean, required:false, default:false}
  },
  data() {
    return {
      inventoryValues: {},
      total: 0
    }
  },
  created() {
    this.refresh();
  },
  methods: {
    async refresh() {
      const results = await this.$apiCall(`query DashboardInventoryValue {
                                            inventoryValues {
                                              items
                                              inBondProducts,dutyPaidProducts
                                              tanks,casks,bulkContainers
                                              fermenters
                                            }
                                          }`, {});
      if (!results.error) {
        this.inventoryValues = results.data.inventoryValues;
        this.total = Object.values(this.inventoryValues).reduce((total,value) => total + value, 0);
      }
    }
  }
}
</script>